export const OpenApiEpro = async () => {
  const respone: Document = await fetch("api/OpenApi/templateregister", {})
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });

  return respone;
};

export const OpenApiRegister = async (documentCode: string) => {
  const respone: Document = await fetch(
    `api/OpenApi/template/${documentCode}`,
    {}
  )
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });

  return respone;
};

export const OpenApiMemorandum = async (data: Document) => {
  data.userPrincipalName = "";
  const respone: Document = await fetch("api/OpenApi/memorandum", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });

  return respone;
};

export const OpenApiMemorandumSeller = async (data: Document) => {
  const respone: Document = await fetch("api/OpenApi/open/memorandum", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });

  return respone;
};

export interface Attribute {
  required: boolean;
  column: any[] | null;
}

export interface Template {
  label: string;
  alter: string;
  type: string;
  attribute: Attribute;
}

export interface MemoData {
  value: any;
  row: any;
}

export interface FormItem {
  template: Template;
  data: MemoData;
  guid: string;
}

export interface Document {
  subject?: string;
  userPrincipalName?: string;
  documentCode: string;
  form: FormItem[];
}
